import {Fragment, useEffect, useState, useRef} from 'react';
import ImageWrapper from '../../ImageWrapper/ImageWrapper';
import ProductBox from '../../ProductBox/ProductBox';
import usePrevious from '../../../helpers/UsePrevious';
import Button from '../../Button/Button';
import SpinnerLoader from '../../SpinnerLoader/SpinnerLoader';
import Debug from '../../../helpers/Debug';
import Navigation from '../../../config/Navigation';
import Viewport from '../../../helpers/Viewport';
import Activity from '../../../helpers/Activity';
import PlaylistItemMetric from '../../../helpers/PlaylistItemMetric';
import {LOG_INACTIVITY_TIME} from '../../../config/App';
import {firestore, getCollectionPath} from '../../../config/Firebase';
import {collection, onSnapshot, query, where} from 'firebase/firestore';
import {productConverter} from '../../../models/Product';
import './PromoGroup.css';

function PromoGroup({playlistId, itemId, id, client, catalog, playlist, promoGroup, loop, start, style, onPlaybackComplete, closeIdleModeManager, getMetadata}) {

    // STYLE PROPERTIES
    const clientName = style && style['global'] && style['global']['clientName'] ? style['global']['clientName'] : undefined;
    const productBoxDesign = style && style['category'] && style['category']['productBoxDesign'] ? style['category']['productBoxDesign'] : undefined;
    const _3dIcon = style && style['category'] && style['category']['3dIcon'] ? style['category']['3dIcon'] : undefined;
    const taxMultiplier = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxMultiplier'] ? style['global']['checkout']['taxMultiplier'] : 1;
    const taxLabel = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxLabel'] ? style['global']['checkout']['taxLabel'] : 'DESC';
    const discountBackgroundColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountBackgroundColor'] ? style['global']['prices']['discountBackgroundColor'] : undefined;
    const discountLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountLabelColor'] ? style['global']['prices']['discountLabelColor'] : undefined;
    const exclusivePriceLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceLabelColor'] ? style['global']['prices']['exclusivePriceLabelColor'] : undefined;
    const exclusivePriceIcon = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceIcon'] ? style['global']['prices']['exclusivePriceIcon'] : undefined;
    const offerBackgroundColor = style && style['global'] && style['global']['offers'] && style['global']['offers']['backgroundColor'] ? style['global']['offers']['backgroundColor'] : undefined;
    const offerLabelColor = style && style['global'] && style['global']['offers'] && style['global']['offers']['labelColor'] ? style['global']['offers']['labelColor'] : undefined;
    const offerLabel = style && style['global'] && style['global']['offers'] && style['global']['offers']['label'] ? style['global']['offers']['label'] : undefined;
    const offerIcon = style && style['global'] && style['global']['offers'] && style['global']['offers']['icon'] ? style['global']['offers']['icon'] : undefined;
    const freeDeliveryIcon = style && style['global'] && style['global']['tags'] && style['global']['tags']['freeDelivery'] && style['global']['tags']['freeDelivery']['icon'] ? style['global']['tags']['freeDelivery']['icon'] : undefined;
    const freeDeliveryLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['freeDelivery'] && style['global']['tags']['freeDelivery']['labelColor'] ? style['global']['tags']['freeDelivery']['labelColor'] : undefined;
    const freeDeliveryBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['freeDelivery'] && style['global']['tags']['freeDelivery']['backgroundColor'] ? style['global']['tags']['freeDelivery']['backgroundColor'] : undefined;
    const deliveryIcon = style && style['global'] && style['global']['tags'] && style['global']['tags']['delivery'] && style['global']['tags']['delivery']['icon'] ? style['global']['tags']['delivery']['icon'] : undefined;
    const deliveryLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['delivery'] && style['global']['tags']['delivery']['labelColor'] ? style['global']['tags']['delivery']['labelColor'] : undefined;
    const deliveryBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['delivery'] && style['global']['tags']['delivery']['backgroundColor'] ? style['global']['tags']['delivery']['backgroundColor'] : undefined;
    const pickupIcon = style && style['global'] && style['global']['tags'] && style['global']['tags']['pickup'] && style['global']['tags']['pickup']['icon'] ? style['global']['tags']['pickup']['icon'] : undefined;
    const pickupLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['pickup'] && style['global']['tags']['pickup']['labelColor'] ? style['global']['tags']['pickup']['labelColor'] : undefined;
    const pickupBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['pickup'] && style['global']['tags']['pickup']['backgroundColor'] ? style['global']['tags']['pickup']['backgroundColor'] : undefined;
    const infoTagBorderColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['borderColor'] ? style['global']['tags']['infoTag']['borderColor'] : undefined;
    const infoTagBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['backgroundColor'] ? style['global']['tags']['infoTag']['backgroundColor'] : undefined;
    const infoTagLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['labelColor'] ? style['global']['tags']['infoTag']['labelColor'] : undefined;
    const otherTagsBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['others'] && style['global']['tags']['others']['backgroundColor'] ? style['global']['tags']['others']['backgroundColor'] : undefined;
    const otherTagsLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['others'] && style['global']['tags']['others']['labelColor'] ? style['global']['tags']['others']['labelColor'] : undefined;
    const sellerLabelColor = style && style['global'] && style['global']['seller'] && style['global']['seller']['labelColor'] ? style['global']['seller']['labelColor'] : undefined;
    const mainSellerIcon = style && style['global'] && style['global']['seller'] && style['global']['seller']['mainIcon'] ? style['global']['seller']['mainIcon'] : undefined;
    const taxDisclaimerBackgroundColor = style && style['category'] && style['category']['taxDisclaimerBackgroundColor'] ? style['category']['taxDisclaimerBackgroundColor'] : undefined;
    const taxDisclaimerLabelColor = style && style['category'] && style['category']['taxDisclaimerLabelColor'] ? style['category']['taxDisclaimerLabelColor'] : undefined;
    const showRating = style && style['category'] ? style['category']['showRating'] : false;
    const showInfoTagOnImage = style && style['category'] ? style['category']['showInfoTagOnImage'] : false;
    const infoTagLabel = style && style['category'] ? style['category']['infoTagLabel'] : undefined;
    const infoTagProperty = style && style['category'] ? style['category']['infoTagProperty'] : undefined;

    // STATE VARIABLES
    const [isLoadingProducts, setIsLoadingProducts] = useState(false);
    const [productsLoaded, setProductsLoaded] = useState(true);
    const [products, setProducts] = useState([]);
    const [slideRemainingTime, setSlideRemainingTime] = useState(promoGroup.duration);
    const [slideDirection, setSlideDirection] = useState('left'); // Start at left so that the first toggleScroll function triggers before the interval.
    const [inInteraction, setInInteraction] = useState(false);
    const [isHovering, setIsHovering] = useState(false);

    // REFERENCES
    const countdownRef = useRef(null);
    const wrapperRef = useRef(null);
    const autoScrollTimerRef = useRef(null);
    const autoScrollAnimationRef = useRef(null);
    const afterInteractionRef = useRef(null);

    // RESPONSIVE PROPERTIES
    const viewport = Viewport.dimensions;
    const showShortTitle = viewport.width < 450 || viewport.height < 650;
    const hideTimerMessage = viewport.width < 900 || viewport.height < 1200;
    const showProductRating = (viewport.width > 900 && viewport.height > 1200) && showRating;
    const hideButtons = viewport.height < 620;

    // VALIDATION FUNCTIONS

    const getValidProducts = (catalog) => {
        return products && products.length > 0 ? products.filter((product) => product.isValid() && product.inCatalog(catalog)) : [];
    };

    const hasValidProducts = (catalog) => {
        const validProducts = getValidProducts(catalog);
        return validProducts && validProducts.length > 0;
    };

    // CALCULATED PROPERTIES
    const validProducts = getValidProducts(catalog);
    const productsWrapperSize = validProducts.length * (280 + 20); // 280px for product box width + 20px for side margins
    const centerProducts = viewport.width > productsWrapperSize;

    // SUBSCRIPTION VARIABLES
    let _unsubscribePromoGroupProducts = null;

    // PREVIOUS STATE VARIABLES
    const previousPromoGroup = usePrevious(promoGroup);

    useEffect(() => {
        setWrapperInteractionListeners();
        return () => {
            stopCountdown();
            stopAutoScroll();
            removeWrapperInteractionListeners();
            unsubscribePromoGroupProducts();
        };
    }, []);

    useEffect(() => {
        const previousPromoGroupProducts = previousPromoGroup && previousPromoGroup.products ? previousPromoGroup.products : [];
        const currentPromoGroupProducts = promoGroup && promoGroup.products ? promoGroup.products : [];
        let anyChange = previousPromoGroupProducts.length !== currentPromoGroupProducts.length;
        if (!anyChange) {
            for (let i = 0; i < currentPromoGroupProducts.length; i++) {
                const currentProductId = currentPromoGroupProducts[i];
                const previousProduct = previousPromoGroupProducts.find(previousProductId => previousProductId === currentProductId);
                if (!previousProduct) {
                    anyChange = true;
                    break;
                }
            }
        }
        if (anyChange) {
            unsubscribePromoGroupProducts();
            setIsLoadingProducts(true);
            setProductsLoaded(false);
            setProducts([]);
        }
    }, [promoGroup]);

    useEffect(() => {
        const anyPromoGroupProducts = promoGroup && promoGroup.products && promoGroup.products.length > 0;
        const anyLoadedProducts = products && products.length > 0;
        if (isLoadingProducts && !productsLoaded && anyPromoGroupProducts && !anyLoadedProducts) getPromoGroupProducts();
        if (start && !isLoadingProducts && productsLoaded) {
            const _hasValidProducts = hasValidProducts(catalog);
            if (!_hasValidProducts) finishPlayback();
            else incrementViewCount();
        }
    }, [start, isLoadingProducts, productsLoaded, products]);

    const getPromoGroupProducts = () => {
        if (!promoGroup || !promoGroup.products || promoGroup.products.length === 0) {
            onProductsLoad([]);
            return;
        }
        const _path = getCollectionPath(client, 'items');
        const _collection = collection(firestore, _path);
        const _where1 = where('id', 'in', promoGroup.products.slice(0, 30)); // 30 products max.
        const _query = query(_collection, _where1).withConverter(productConverter);
        _unsubscribePromoGroupProducts = onSnapshot(_query, (_snapshot) => {
            const newProducts = products.map(product => product.clone());
            _snapshot.docChanges().forEach((change) => {
                if (change.type === 'added') {
                    newProducts.push(change.doc.data());
                } else if (change.type === 'modified') {
                    const index = newProducts.findIndex(product => product.id === change.doc.id);
                    if (index >= 0) newProducts[index] = change.doc.data();
                } else if (change.type === 'removed') {
                    const index = newProducts.findIndex(product => product.id === change.doc.id);
                    if (index >= 0) newProducts.splice(index, 1);
                }
            });
            onProductsLoad(newProducts);
        }, (error) => {
            Debug.printToLog('error', error);
            onProductsLoad([]);
        });
    };

    const onProductsLoad = (products) => {
        setIsLoadingProducts(false);
        setProductsLoaded(true);
        setProducts(products);
    };

    const unsubscribePromoGroupProducts = () => {
        if (_unsubscribePromoGroupProducts) _unsubscribePromoGroupProducts();
    };

    useEffect(() => {
        if (start) {
            startAutoScroll('delayed');
            loop ? stopCountdown() : startCountdown('create');
        } else {
            stopCountdown();
            stopAutoScroll();
        }
    }, [
        start,
        loop,
        promoGroup.duration,
        promoGroup.onLoadStartAutoScrollAfter,
        promoGroup.autoScrollAnimationDuration,
        promoGroup.autoScrollNextAnimationDelay,
        promoGroup.onInteractionEndResumeAutoScrollAfter
    ]);

    useEffect(() => {
        if (slideRemainingTime <= 0) finishPlayback();
    }, [slideRemainingTime]);

    const incrementViewCount = () => {
        const metadata = getMetadata();
        const client = metadata ? metadata.client : undefined;
        const instance = metadata ? metadata.instance : undefined;
        PlaylistItemMetric.incrementViewCount(playlistId, itemId, 'promo-group', client, instance);
    };

    const finishPlayback = () => {
        stopCountdown();
        if (onPlaybackComplete) onPlaybackComplete();
    };

    const setWrapperInteractionListeners = () => {
        if (wrapperRef && wrapperRef.current) {
            const options = {capture: true, passive: false};
            wrapperRef.current.addEventListener('mousedown', onUserInteractionStart, options);
            wrapperRef.current.addEventListener('touchstart', onUserInteractionStart, options);
            wrapperRef.current.addEventListener('mouseup',  onUserInteractionEnd, options);
            wrapperRef.current.addEventListener('touchend', onUserInteractionEnd, options);
        }
    };

    const removeWrapperInteractionListeners = () => {
        if (wrapperRef && wrapperRef.current) {
            const options = {capture: true, passive: false};
            wrapperRef.current.removeEventListener('mousedown', onUserInteractionStart, options);
            wrapperRef.current.removeEventListener('touchstart', onUserInteractionStart, options);
            wrapperRef.current.removeEventListener('mouseup',  onUserInteractionEnd, options);
            wrapperRef.current.removeEventListener('touchend', onUserInteractionEnd, options);
        }
    };

    const onUserInteractionStart = () => {
        setInInteraction(true);
        if (!loop) pauseCountdown();
        stopAutoScroll();
    };

    const onUserInteractionEnd = () => {
        if (afterInteractionRef && afterInteractionRef.current) clearTimeout(afterInteractionRef.current);
        afterInteractionRef.current = setTimeout(() => {
            if (!loop) unpauseCountdown();
            startAutoScroll('instant');
            setInInteraction(false);
        }, promoGroup.onInteractionEndResumeAutoScrollAfter);
    };

    const startCountdown = (mode = 'create') => {
        if (mode === 'create') stopCountdown();
        if (LOG_INACTIVITY_TIME) Debug.printToLog('info', `PromoGroup ${id} | ${mode === 'create' ? 'Starting' : 'Resuming'} countdown`);
        countdownRef.current = setInterval(() => {
            setSlideRemainingTime(slideRemainingTime => {
                let _slideRemainingTime;
                if (slideRemainingTime > 1000) _slideRemainingTime = slideRemainingTime - 1000;
                else _slideRemainingTime = 0;
                if (LOG_INACTIVITY_TIME) Debug.printToLog('info', `PromoGroup ${id} | Remaining time until idle mode slide change: ${Math.round(_slideRemainingTime / 1000)} seconds`);
                return _slideRemainingTime;
            });
        }, 1000);
    };

    const stopCountdown = () => {
        if (LOG_INACTIVITY_TIME) Debug.printToLog('info', `PromoGroup ${id} | Stopping countdown`);
        if (countdownRef && countdownRef.current) {
            clearInterval(countdownRef.current);
            countdownRef.current = null;
            setSlideRemainingTime(promoGroup.duration);
        }
    };

    const pauseCountdown = () => {
        if (LOG_INACTIVITY_TIME) Debug.printToLog('info', `PromoGroup ${id} | Pausing countdown`);
        if (countdownRef && countdownRef.current) clearInterval(countdownRef.current);
    };

    const unpauseCountdown = () => {
        if (LOG_INACTIVITY_TIME) Debug.printToLog('info', `PromoGroup ${id} | Unpausing countdown`);
        startCountdown('resume');
    };

    const startAutoScroll = (mode = 'delayed') => {
        stopAutoScroll();
        if (LOG_INACTIVITY_TIME) Debug.printToLog('info', `PromoGroup ${id} | Starting auto scroll`);
        setTimeout(() => {
            toggleScroll(); // Toggle initial scroll from left to right to start the first animation.
            autoScrollTimerRef.current = setInterval(() => {
                toggleScroll();
            }, promoGroup.autoScrollAnimationDuration + promoGroup.autoScrollNextAnimationDelay);
        }, mode === 'instant' ? 0 : promoGroup.onLoadStartAutoScrollAfter);
    };

    const stopAutoScroll = () => {
        if (LOG_INACTIVITY_TIME) Debug.printToLog('info', `PromoGroup ${id} | Stopping auto scroll`);
        if (autoScrollTimerRef && autoScrollTimerRef.current) {
            clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
        if (autoScrollAnimationRef && autoScrollAnimationRef.current) {
            autoScrollAnimationRef.current.cancel();
            autoScrollAnimationRef.current = null;
        }
    };

    const toggleScroll = () => {
        setSlideDirection((slideDirection) => {
            if (slideDirection === 'left') return 'right';
            return 'left';
        });
    };

    useEffect(() => {
        if (start && wrapperRef && wrapperRef.current) {
            const initialScroll = wrapperRef.current.scrollLeft;
            let scrollProportion = 0;
            let targetScroll = 0;
            switch (slideDirection) {
                case 'left':
                    const initialScrollFromRight = productsWrapperSize - (wrapperRef.current.scrollLeft + viewport.width);
                    const targetScrollFromRight = productsWrapperSize - viewport.width;
                    scrollProportion = initialScrollFromRight / targetScrollFromRight;
                    targetScroll = 0;
                    break;
                default:
                    const initialScrollFromLeft = wrapperRef.current.scrollLeft;
                    const targetScrollFromLeft = productsWrapperSize - viewport.width;
                    scrollProportion = initialScrollFromLeft / targetScrollFromLeft;
                    targetScroll = targetScrollFromLeft;
                    break;
            }
            if (scrollProportion === 1) {
                if (LOG_INACTIVITY_TIME) Debug.printToLog('info', `PromoGroup ${id} | Initial scroll position in the target position, switching sides to prevent dead time`);
                toggleScroll();
            } else {
                const autoScrollAnimationDuration = promoGroup.autoScrollAnimationDuration * (1 - scrollProportion);
                if (LOG_INACTIVITY_TIME) Debug.printToLog('info', `PromoGroup ${id} | Scrolling from ${initialScroll}px to ${targetScroll}px, duration: ${promoGroup.autoScrollAnimationDuration}ms`);
                autoScrollAnimationRef.current = smoothScrollTo(wrapperRef.current, targetScroll, autoScrollAnimationDuration);
            }
        }
    }, [slideDirection]);

    const smoothScrollTo = (element, target, duration = 1000) => {
        if (!element) return;
        const start = element.scrollLeft;
        const distance = target - start;
        const startTime = performance.now();
        let animationFrameId;
        let cancelled = false;
        const step = (currentTime) => {
            if (cancelled) return;
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1); // Force the value to be between 0 and 1
            element.scrollLeft = start + (distance * progress);
            if (progress < 1) animationFrameId = requestAnimationFrame(step);
        }
        animationFrameId = requestAnimationFrame(step);
        return {
            cancel: () => {
                cancelled = true;
                cancelAnimationFrame(animationFrameId);
            }
        };
    };

    const handleProductClick = (_category, product, _index) => {
        const metadata = getMetadata();
        Activity.log(metadata, 'promo-group', product.id, 'click', true, {
            playlist_id: playlist.id,
            playlist_name: playlist.name || null,
            promo_group: promoGroup.id || null,
            promo_group_layout: promoGroup.layout || null,
            product_id: product.id,
            product_name: product.name || null
        });
        const url = Navigation.getProductUrl(product.id, undefined, undefined);
        Navigation.forceRedirect(url);
    };

    const handleGoToHome = () => {
        if (closeIdleModeManager) {
            // No metric needed, when the user closes the promo group, the idle mode manager close metric is triggered.
            closeIdleModeManager();
        }
    };

    const handleCloseButtonMouseEnter = () => {
        setIsHovering(true);
    };

    const handleCloseButtonMouseLeave = () => {
        setIsHovering(false);
    };

    const containerStyle = () => {
        const anyProducts = validProducts && validProducts.length > 0;
        return {
            opacity: start && anyProducts ? 1 : 0,
            background: promoGroup.background.type === 'css' ? promoGroup.background.value : '#000000'
        };
    };

    const loaderStyle = () => {
        const anyProducts = validProducts && validProducts.length > 0;
        return {
            opacity: !start || !anyProducts ? 1 : 0
        };
    };

    const closeButtonStyle = () => {
        return {
            filter: isHovering ? 'brightness(85%)' : 'unset',
            transform: `scale(${isHovering ? 1.1 : 1})`
        };
    };

    const titleStyle = () => {
        return {
            color: promoGroup.title.color || '#000000'
        };
    };

    const subtitleStyle = () => {
        return {
            color: promoGroup.subtitle.color || '#000000'
        };
    };

    const wrapperStyle = () => {
        return {
            justifyContent: centerProducts ? 'center' : 'flex-start'
        };
    };

    const timerStyle = () => {
        const duration = promoGroup.duration;
        const elapsedTime = promoGroup.duration - slideRemainingTime;
        const percentage = duration > 0 ? ((elapsedTime * 100) / duration) : 0;
        return {
            background: `conic-gradient(#000000 ${percentage}%, #4D4D4D 0%)`
        };
    };

    return (
        <Fragment>
            <div className='promo-group-loader' style={loaderStyle()}>
                <SpinnerLoader size={100} color='#ffffff'/>
            </div>
            <div className='promo-group' style={containerStyle()}>
                {hideButtons && (
                    <div className='promo-group-close-button' onMouseEnter={handleCloseButtonMouseEnter} onMouseLeave={handleCloseButtonMouseLeave} onClick={handleGoToHome} style={closeButtonStyle()}>
                        <span className='promo-group-close-button-icon'>x</span>
                    </div>
                )}
                <div className='promo-group-top-image'>
                    {promoGroup.topImage && (
                        <ImageWrapper
                            image={promoGroup.topImage}
                            alt='Top'
                            display='block'
                            width='100%'
                            height='auto'
                            errorWidth={undefined}
                            errorHeight={undefined}
                            errorPadding={undefined}
                            backgroundColor={undefined}
                            margin={undefined}
                            padding={undefined}
                            borderRadius={undefined}
                            transition={true}
                            loadDelay={0}
                            onLoad={undefined}
                        />
                    )}
                </div>
                {promoGroup.title && promoGroup.title.content && (
                    <div className='promo-group-title' style={titleStyle()}>{showShortTitle ? '¡Ofertas!' : promoGroup.title.content}</div>
                )}
                {promoGroup.subtitle && promoGroup.subtitle.content && (
                    <div className='promo-group-subtitle' style={subtitleStyle()}>{promoGroup.subtitle.content}</div>
                )}
                <div className='promo-group-products'>
                    <div ref={wrapperRef} className='promo-group-wrapper' style={wrapperStyle()}>
                        {validProducts.map((product, index) => (
                            <ProductBox
                                key={`promo-group-${id}-${product.id}`}
                                idPrefix={`promo-group-${id}`}
                                index={index}
                                category={undefined}
                                product={product}
                                showSku={false}
                                showIcons={false}
                                active={false}
                                clientName={clientName}
                                design={productBoxDesign}
                                _3dIcon={_3dIcon}
                                isFeatured={false}
                                shouldDraw3D={false}
                                shouldDrawGallery={false}
                                taxMultiplier={taxMultiplier}
                                taxLabel={taxLabel}
                                discountBackgroundColor={discountBackgroundColor}
                                discountLabelColor={discountLabelColor}
                                exclusivePriceLabelColor={exclusivePriceLabelColor}
                                exclusivePriceIcon={exclusivePriceIcon}
                                offerBackgroundColor={offerBackgroundColor}
                                offerLabelColor={offerLabelColor}
                                offerLabel={offerLabel}
                                offerIcon={offerIcon}
                                freeDeliveryIcon={freeDeliveryIcon}
                                freeDeliveryLabelColor={freeDeliveryLabelColor}
                                freeDeliveryBackgroundColor={freeDeliveryBackgroundColor}
                                deliveryIcon={deliveryIcon}
                                deliveryLabelColor={deliveryLabelColor}
                                deliveryBackgroundColor={deliveryBackgroundColor}
                                pickupIcon={pickupIcon}
                                pickupLabelColor={pickupLabelColor}
                                pickupBackgroundColor={pickupBackgroundColor}
                                infoTagBorderColor={infoTagBorderColor}
                                infoTagBackgroundColor={infoTagBackgroundColor}
                                infoTagLabelColor={infoTagLabelColor}
                                otherTagsBackgroundColor={otherTagsBackgroundColor}
                                otherTagsLabelColor={otherTagsLabelColor}
                                sellerLabelColor={sellerLabelColor}
                                mainSellerIcon={mainSellerIcon}
                                taxDisclaimerBackgroundColor={taxDisclaimerBackgroundColor}
                                taxDisclaimerLabelColor={taxDisclaimerLabelColor}
                                featuredDefaultIcon={undefined}
                                featuredDefaultLabel={undefined}
                                featuredDefaultMediaWidthPercentage={undefined}
                                featuredWidthMultiplier={undefined}
                                featuredBackgroundColor={undefined}
                                featuredLabelColor={undefined}
                                showPulseEffect={false}
                                pulseEffectColor={undefined}
                                pulseEffectIterations={0}
                                selected={false}
                                selectedBorderColor={undefined}
                                showTopBanner={false}
                                showSeller={false}
                                showDelivery={false}
                                showRating={showProductRating}
                                showTags={false}
                                showInfoTagOnImage={showInfoTagOnImage}
                                infoTagLabel={infoTagLabel}
                                infoTagProperty={infoTagProperty}
                                visible={true}
                                disabled={false}
                                onClick={handleProductClick}
                            />
                        ))}
                    </div>
                </div>
                {!hideButtons && (
                    <div className='promo-group-button-container'>
                        <div className='promo-group-button'>
                            <Button
                                label={promoGroup.closeButton.label}
                                labelColor={promoGroup.closeButton.labelColor}
                                backgroundColor={promoGroup.closeButton.backgroundColor}
                                borderColor={promoGroup.closeButton.borderColor}
                                width='100%'
                                borderRadius={10}
                                boxShadow='unset'
                                onClick={handleGoToHome}
                            />
                        </div>
                    </div>
                )}
                <div className='promo-group-bottom-image'>
                    {promoGroup.bottomImage && (
                        <ImageWrapper
                            image={promoGroup.bottomImage}
                            alt='Bottom'
                            display='block'
                            width='100%'
                            height='auto'
                            errorWidth={undefined}
                            errorHeight={undefined}
                            errorPadding={undefined}
                            backgroundColor={undefined}
                            margin={undefined}
                            padding={undefined}
                            borderRadius={15}
                            transition={true}
                            loadDelay={0}
                            onLoad={undefined}
                        />
                    )}
                </div>
                {!loop && (
                    <div className='promo-group-timer'>
                        <span className='promo-group-timer-label'>
                            {!inInteraction && (
                                <Fragment>
                                    {hideTimerMessage ? '' : 'Este espacio promocional se cerrará en'}
                                    <span className='promo-group-timer-value' style={timerStyle()}>{Math.round(slideRemainingTime / 1000)}</span>
                                    {hideTimerMessage ? '' : 'segundo(s)'}
                                </Fragment>
                            )}
                            {inInteraction && (
                                <Fragment>
                                    {hideTimerMessage ? '' : 'Cierre pausado temporalmente por interacción'}
                                </Fragment>
                            )}
                        </span>
                    </div>
                )}
            </div>
        </Fragment>
    );
}

export default PromoGroup;